import React, { ReactElement, useContext, useEffect, useState } from "react"
import DatiNazionali from "./DatiNazionali"
import DatiRegionali from "./DatiRegionali"
import DatiNazionaliMultiAnno from "./DatiNazionaliMultiAnno"
import {MultiAnnoContext} from "@/context/MultiAnnoContext"
import DatiRegionaliMultiAnno from "./DatiRegionaliMultiAnno"

interface VisualizzaDatiProps {
    anno: string
    codIsa?: string
    macroarea?: string
    tipologia?: string
}

function VisualizzaDati(props: VisualizzaDatiProps) {
    const [view, setView] = useState<ReactElement>()
    const [multiAnnoState, _] = useContext(MultiAnnoContext)

    useEffect(() => {
        if (props.tipologia?.includes("Nazionali")) {
            if (multiAnnoState.isMultiAnno) {
                setView(
                    <DatiNazionaliMultiAnno
                        anno={props.anno}
                        tipologia={props.tipologia}
                        macroarea={props.macroarea}
                        codIsa={props.codIsa}
                    />
                )
            } else {
                setView(
                    <DatiNazionali
                        anno={props.anno}
                        tipologia={props.tipologia}
                        macroarea={props.macroarea}
                        codIsa={props.codIsa}
                    />
                )
            }
        } else {
             if (multiAnnoState.isMultiAnno) {
                 setView(
                     <DatiRegionaliMultiAnno
                        anno={props.anno}
                         tipologia={props.tipologia}
                         macroarea={props.macroarea}
                         codIsa={props.codIsa}
                     />
                 )
             } else 
            {
                setView(
                    <DatiRegionali
                        anno={props.anno}
                        tipologia={props.tipologia}
                        macroarea={props.macroarea}
                        codIsa={props.codIsa}
                    />
                )
            }
        }
        return () => {}
    }, [props.anno, props.tipologia, props.codIsa, props.macroarea])

    return <React.Fragment>{view}</React.Fragment>
}

export default VisualizzaDati
